var trackEvent;

module.exports = trackEvent = function(eventName, payload) {
  var defaults, ref;
  if (payload == null) {
    payload = {};
  }
  defaults = {
    b: Cookie.get('b'),
    pageId: location.pathname
  };
  payload = _.extend({}, payload, defaults);
  if (typeof OptimizeSuite !== "undefined" && OptimizeSuite !== null) {
    if ((ref = OptimizeSuite.TrackingHub) != null) {
      ref.add("" + eventName, payload);
    }
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvY29yZS9mcm9udGVuZC9ncm91cG9uX21vZHVsZXMvdHJhY2tFdmVudC5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvYXJpY2h0ZXIvcmVwb3NpdG9yaWVzL3Nscy9jb3JlL2Zyb250ZW5kL2dyb3Vwb25fbW9kdWxlcy90cmFja0V2ZW50LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxJQUFBOztBQUFBLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLFVBQUEsR0FBYSxTQUFDLFNBQUQsRUFBWSxPQUFaO0FBQzVCLE1BQUE7O0lBRHdDLFVBQVU7O0VBQ2xELFFBQUEsR0FDRTtJQUFBLENBQUEsRUFBRyxNQUFNLENBQUMsR0FBUCxDQUFXLEdBQVgsQ0FBSDtJQUNBLE1BQUEsRUFBUSxRQUFRLENBQUMsUUFEakI7O0VBRUYsT0FBQSxHQUFVLENBQUMsQ0FBQyxNQUFGLENBQVMsRUFBVCxFQUFhLE9BQWIsRUFBc0IsUUFBdEI7OztTQUVnQixDQUFFLEdBQTVCLENBQWdDLEVBQUEsR0FBRyxTQUFuQyxFQUFnRCxPQUFoRDs7O0FBTjRCIn0=
